module.exports = __webpack_public_path__ + "img/L_KS.c199fbc6.png";